module.exports = __webpack_public_path__ + "img/border-style.6faccd31.svg";